<script>
	import { slide } from "svelte/transition";
	import { uiText } from "../lib/uiText.js";
	import { createEventDispatcher } from "svelte";
	const dispatch = createEventDispatcher();
	export let lang = "en";
	let ui = uiText(lang);
	$: lang, (ui = uiText(lang));
	// export let vendor = ui.game.footer.vendor;
	let showHelpInfo = false;
	let showLangSelector = false;
	export let surrender = false;
	export let hasMap = false;
	export let mapOpen = false;
	export let hasChat = false;
	export let chatOpen = false;
	export let unreadCount = 0;
</script>

<header
	id="header"
	class="box-border flex justify-between h-20 text-base bg-blue-100 obelisk"
>
	<img
		id="hdr-img-row"
		class="hidden h-full max-h-full p-4 {!hasMap && !hasChat
			? 'xs:block'
			: 'sm:block'}"
		src={lang === "bg" ? "/img/svg/logo-bg.svg" : "/img/svg/logo-en.svg"}
		alt={ui.game.footer.vendor}
	/>
	<img
		id="hdr-img-icon"
		class="block h-full max-h-full p-4 {!hasMap && !hasChat
			? 'xs:hidden'
			: 'sm:hidden'}"
		src="/img/svg/logo-icon.svg"
		alt={lang === "bg" ? "Вътрешен Глас" : "Inner Voice"}
	/>

	{#if hasMap}
		<button
			id="hdr-btn-map"
			class="ghost icon {mapOpen ? 'map-open' : 'map-default'}"
			style="margin-left:auto; margin-right:0"
			on:click={() => ((mapOpen = !mapOpen), dispatch("map", mapOpen))}
			title={ui.map.map_header_title}
		>
			{#if mapOpen}
				<i
					class="fa-solid fa-times fa-fw"
					aria-hidden="true"
					data-position="center"
				/>
			{:else}
				<i
					class="fa-solid fa-map-location-dot fa-fw"
					aria-hidden="true"
					data-position="center"
				/>
			{/if}
		</button>
	{/if}

	{#if hasChat}
		<!-- <button
			class="ghost icon"
			style="margin-left:auto; margin-right:0"
			on:click={() => (
				(chatOpen = !chatOpen),
				dispatch("chat", chatOpen),
				console.log(chatOpen)
			)}
			title={ui.chat.chat_header_title}
		>
			{#if chatOpen}
				<i
					class="fa-solid fa-times fa-fw"
					aria-hidden="true"
					data-position="center"
				/>
			{:else}
				<i
					class="fa-solid fa-messages fa-fw"
					aria-hidden="true"
					data-position="center"
				/>
			{/if}
		</button> -->
		<button
			id="hdr-btn-chat"
			class="relative ghost icon {chatOpen
				? 'chat-open'
				: 'chat-default'} {unreadCount > 0 ? 'has-unread' : ''}"
			style="{hasMap ? '' : 'margin-left:auto;'} margin-right:0; "
			on:click={() => {
				chatOpen = !chatOpen;
				dispatch("chat", chatOpen);
			}}
			title={ui.chat.chat_header_title}
		>
			<!-- THE NOTIFICATION BADGE -->
			{#if unreadCount > 0}
				<div
					class="absolute b-ping flex items-center justify-center w-5 h-5 text-xs text-blue-200 bg-yellow rounded-full -top-1 -right-1 animate-pulse"
				>
					{unreadCount > 9 ? "9+" : unreadCount}
				</div>
			{/if}

			{#if chatOpen}
				<i class="fa-solid fa-times fa-fw" aria-hidden="true" />
			{:else}
				<i class="fa-solid fa-messages fa-fw" aria-hidden="true" />
			{/if}
		</button>
	{/if}

	<!-- SURRENDER BTN -->
	<button
		id="hdr-btn-surrender"
		class="ghost icon {surrender ? 'sur-open' : 'sur-default'}"
		style={hasMap || hasChat
			? "margin-right:0"
			: "margin-left:auto; margin-right:0"}
		on:click={() => (
			(surrender = !surrender), dispatch("surrender", surrender)
		)}
		title={ui.game.header.surrender_title}
	>
		{#if surrender}
			<i
				class="fa-solid fa-times fa-fw"
				aria-hidden="true"
				data-position="center"
			/>
		{:else}
			<i
				class="fa-solid fa-user-xmark fa-fw"
				aria-hidden="true"
				data-position="center"
			/>
		{/if}
	</button>

	<!-- SHOW HELP INFO BTN -->
	<button
		id="hdr-btn-info"
		class="ghost icon {showHelpInfo ? 'info-open' : 'info-default'}"
		style="margin-right:0"
		on:click={() => (
			(showLangSelector = false), (showHelpInfo = !showHelpInfo)
		)}
		title={ui.game.header.help_title}
	>
		{#if showHelpInfo}
			<i
				class="fa-solid fa-times fa-fw"
				aria-hidden="true"
				data-position="center"
			/>
		{:else}
			<i
				class="fa-solid fa-circle-question fa-fw"
				aria-hidden="true"
				data-position="center"
			/>
		{/if}
	</button>

	<!-- SHOW LANG SELECTOR BTN -->
	<button
		id="hdr-btn-lang"
		class="ghost icon {showLangSelector ? 'lang-open' : 'lang-default'}"
		on:click={() => (
			(showHelpInfo = false), (showLangSelector = !showLangSelector)
		)}
		title={ui.game.header.lang_title}
	>
		{#if showLangSelector}
			<i
				class="fa-solid fa-times fa-fw"
				aria-hidden="true"
				data-position="center"
			/>
		{:else}
			<i
				class="fa-solid fa-language fa-fw"
				aria-hidden="true"
				data-position="center"
			/>
		{/if}
	</button>

	<!-- LANGUAGE SELECTOR -->
	{#if showLangSelector}
		<div
			transition:slide
			class="absolute right-0 grid bg-blue-100 lang-selector top-20 bg-opacity-90"
		>
			<button
				on:click={() => (
					(lang = "bg"),
					(showLangSelector = false),
					dispatch("setLang", { lang: lang, prefset: true })
				)}>Български (Bulgarian)</button
			>
			<button
				on:click={() => (
					(lang = "en"),
					(showLangSelector = false),
					dispatch("setLang", { lang: lang, prefset: true })
				)}>English (Английски)</button
			>
		</div>
	{/if}

	<!-- HELP INFO -->
	{#if showHelpInfo}
		<div
			transition:slide
			class="absolute right-0 grid bg-blue-100 lang-selector top-20 bg-opacity-90 p-[10px] max-w-full"
		>
			<h3>{ui.help.title}</h3>
			<p>{ui.help.description}</p>

			<a href={ui.help.messenger_link}>{ui.help.messenger}</a>
			<a href={ui.help.instagram_link}>{ui.help.instagram}</a>
			<a href={ui.help.email_link}>{ui.help.email}</a>
		</div>
	{/if}
</header>

<style>
	.obelisk button.has-unread {
		background: #fdda0033;
	}
	:global(.b-ping:before) {
		content: "";
		position: absolute;
		background: inherit;
		inset: 0;
		border: inherit;
		border-radius: inherit;
		z-index: -1;
		animation: ping 1s cubic-bezier(0, 0, 0, 1) infinite;
		opacity: inherit;
		color: inherit;
	}
</style>
